
export type User = {
  id: string;
  tenantId: string;
  lastName?: string;
  firstName?: string;
  lastNameKana?: string;
  firstNameKana?: string;
  birthDate?: Date;
  sex?: number;
  phoneNumber?: string;
  faxNumber?: string;
  iconURL?: string;
  familyEmail?: string;
  tag?: string[];
  groupCount?: number;
  devicesCount?: number;
  createAt?: Date;
  updateAt: Date;
  admin?: boolean;
  deleteFlg?: boolean;
  accountSuspensionFlg: boolean;
  note?: string;
  firstLoginDate?: Date;
  deleteAt?: Date | null;
  zipCode?: string;
  address?: string;
  searchKey1?: string;
  searchKey2?: string;
  searchKey3?: string;
  displayId?: string;
  pointAssignmentAuthority?: boolean | null;
}

export const UserItemMaping = (data: any | undefined): User | UserData => {
  data.familyEmail = data?.familyEmail !== undefined
    ? data?.familyEmail.join(",")
    : "";
  data.birthDate = data?.birthDate !== null
    ? new Date(data?.birthDate?.seconds * 1000)
    : data?.birthDate;
  data.createAt = new Date(data?.createAt?.seconds * 1000);
  data.updateAt = data?.updateAt !== null
    ? new Date(data?.updateAt.seconds * 1000)
    : new Date();
  data.firstLoginDate = data?.firstLoginDate !== null
    ? new Date(data?.firstLoginDate?.seconds * 1000)
    : data?.firstLoginDate;
  return data;
}

export type UserData = User & {
  groups: GroupsSetting[],
  salt?: string | null,
  encryptedPasscode?: string | null,
  decryptedPasscode?: string | null,
  password?: string | null,
  passcode?: string | null,
  iv?: Blob | null,
  possessedPointMap?: possessedPointMap[],
  expirationPointMap?: expirationPointMap[],
};

export type possessedPointMap = {
  id?: string,
  name?: string,
  point?: number,
};

export type expirationPointMap = {
  id?: string,
  name?: string,
  point?: number,
  expirationDate?: Date,
}

export type GroupsSetting = {
  id: string;
  name: string;
  color: "blue" | "green" | "red" | "yellow" | "indigo" | "purple" | "pink" | "gray";
  disabled?: boolean | null | undefined;
  adminFlg?: boolean | undefined;
}
